




















import { computed, defineComponent, ref } from "@vue/composition-api";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import UserSubscribeModal from "../UserSubscribeModal";

export default defineComponent({
  name: "UserFollowSubscribeModal",
  components: { UserSubscribeModal },
  props: {
    show: { type: Boolean, required: true },
    isFollowing: { type: Boolean, required: true },
    user: { type: Object as () => UserPublicData, required: true },
  },

  setup(props, { emit }) {
    const hasLevels = ref(false);
    const showModal = computed(() => props.show && hasLevels.value);
    const onClose = (status = props.isFollowing) => {
      emit("close");
      emit("updateFollowingStatus", status);
    };

    const onLevelsLoaded = (levels: SubscriptionLevel[]) => {
      hasLevels.value = levels.length > 0;
      if (props.show && !hasLevels.value && !props.isFollowing) {
        // should immediately subscribe.
        emit("toggleFollow");
      }
    };

    return {
      onLevelsLoaded,
      showModal,
      onClose,
    };
  },
});
